import { PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, message, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePosts } from "../../../../hooks/usePost";
import { PostFilter } from "../components/PostFilter";
import { PostList } from "../components/PostList";

const { Title } = Typography;

export function PostsPage() {
  const [filter, setFilter] = useState({ page: 1, limit: 10 });
  const { data, loading, total, remove } = usePosts(filter);
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      await remove.mutateAsync(id);
      message.success("Xóa dữ liệu thành công");
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[{ title: "Bảng điều khiển" }, { title: "Tin tức" }]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Quản lý tin tức
          </Title>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/bang-dieu-khien/tin-tuc/create")}
        >
          Thêm tin tức
        </Button>
      </div>

      <div style={{ padding: "24px 0" }}>
        <PostFilter filter={filter} onFilterChange={handleFilterChange} />
      </div>

      <div>
        <PostList
          data={data}
          total={total}
          loading={loading}
          filter={filter}
          onFilterChange={handleFilterChange}
          onEdit={(item) => navigate(`/bang-dieu-khien/tin-tuc/${item._id}`)}
          onDelete={handleDelete}
        />
      </div>
    </div>
  );
}
